export default __webpack_public_path__ + "static/valuation_img_1-db0265a77bc586bda7f40d43ed47dd1f.png";